import React, { useState, useEffect } from "react";
import { Select, Form, Input, Radio, Checkbox } from "antd";
const { Option } = Select;

const runStatusRange = [
  {
    label: "运行",
    value: "1",
  },
  {
    label: "热备",
    value: "0",
  },
];
const PatrolItem = ({
  defectslevelLs,
  fields,
  numericFlag,
  chooseCycle,
  layout,
}) => {
  const [isNumber, setIsNumber] = useState();

  useEffect(() => {
    setIsNumber(numericFlag);
  }, [numericFlag]);

  const changeNumType = (e) => {
    setIsNumber(e.target.value);
  };

  return (
    <>
      <Form.Item
        label="缺陷等级"
        name={fields.defectLevelId}
        rules={[{ required: true, message: "请选择缺陷等级" }]}
        {...layout}
      >
        <Select placeholder={"请选择缺陷等级"}>
          {defectslevelLs &&
            defectslevelLs.map((item) => {
              return (
                <Option value={item.id} key={item.id}>
                  {item.defectLevelName}
                </Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        label="巡检内容"
        name={fields.itemContent}
        rules={[{ required: true, message: "巡检内容!" }]}
        {...layout}
      >
        <Input placeholder="请输入巡检内容" />
      </Form.Item>
      <Form.Item
        label="填写数值"
        name={fields.numericFlag}
        rules={[{ required: true, message: "是否填写数值!" }]}
        {...layout}
      >
        <Radio.Group onChange={changeNumType}>
          <Radio value={0}>否</Radio>
          <Radio value={1}>是</Radio>
        </Radio.Group>
      </Form.Item>
      {isNumber === 1 && (
        <>
          <Form.Item label="单位" name={fields.unit} {...layout}>
            <Input placeholder="请输入单位" />
          </Form.Item>
          <Form.Item label="上限值" name={fields.upperLimit} {...layout}>
            <Input placeholder="请输入上限值" />
          </Form.Item>
          <Form.Item label="下限值" name={fields.lowerLimit} {...layout}>
            <Input placeholder="请输入下限值" />
          </Form.Item>
        </>
      )}
      <Form.Item
        label="运行状态"
        name={fields.runStatus}
        rules={[{ required: false, message: "运行状态!" }]}
        {...layout}
      >
        <Checkbox.Group options={runStatusRange} />
      </Form.Item>
      <Form.Item
        label="安全隐患"
        name={fields.safetyPerilFlag}
        rules={[{ required: true, message: "请选择是否安全隐患!" }]}
        {...layout}
      >
        <Radio.Group>
          <Radio value={0}>否</Radio>
          <Radio value={1}>是</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="周期"
        name={fields.period}
        rules={[{ required: true, message: "请选择周期" }]}
        {...layout}
      >
        <Select placeholder="请选择周期" onChange={chooseCycle}>
          <Option value={0}>天</Option>
          <Option value={1}>周</Option>
          <Option value={2}>月</Option>
          <Option value={3}>季度</Option>
        </Select>
      </Form.Item>
    </>
  );
};

export default React.memo(PatrolItem);
